import './side-overlay.scss';
import Swiper from 'swiper';
import { Pagination, Mousewheel, FreeMode, Manipulation } from 'swiper/modules';
import AjaxLoad from './../../utilities/js/ajax-load';

class SideOverlay {
    constructor ($element) {
        this.$sideOverlayButton = $element;
        this.$overlayType = this.$sideOverlayButton.getAttribute('data-side-overlay-type');
        this.$overlay = this.$sideOverlayButton.closest('section').querySelector('.' + this.$overlayType);
        this.$closeButton = this.$overlay.querySelector('.side-overlay__close');
        this.overlayOpen = false;

        this.$overlaySlider = this.$overlay.querySelector('[data-side-overlay-slider="slider"]');
        this.$sizeFinderSlider = this.$overlay.querySelector('[data-size-finder-slider="slider"]');
        this.$sizeFinderBack = this.$overlay.querySelector('[data-size-finder-back]');
        this.slider = null;
        this.sizeFinderSlider = null;
        this.isLoading = false;
    }

    initialize () {
        if (this.$sideOverlayButton) {
            this.setEvents();
        }
    }

    setEvents () {
        this.$sideOverlayButton.addEventListener('click', () => {
            this.openOverlay();
        });

        this.$closeButton.addEventListener('click', () => {
            this.closeOverlay();
        });

        document.body.addEventListener('click', (e) => {
            if (this.overlayOpen) {
                const $clickedElement = e.target;
                let dataOverlay = $clickedElement.getAttribute('data-side-overlay');
                if (!dataOverlay) {
                    const $parentElement = $clickedElement.closest('[data-side-overlay]');
                    const sizeFinderButton = $clickedElement.getAttribute('data-size-finder');
                    if ($parentElement || sizeFinderButton === 'end' || sizeFinderButton === 'restart') {
                        dataOverlay = true;
                    }
                }

                if (!dataOverlay) {
                    this.closeOverlay();
                }
            }
        });
    }

    openOverlay () {
        this.$overlay.classList.add('is--visible');
        this.overlayOpen = true;

        if (this.$overlaySlider) {
            this.initSlider();
            this.resizeSlider();
        }

        if (this.$overlayType === 'detail-stage__size-finder') {
            this.initSizeFinder();
        }
    }

    closeOverlay () {
        if (this.sizeFinderSlider) {
            this.sizeFinderSlider.destroy();
        }
        if (this.$sizeFinderBack) {
            this.$sizeFinderBack.classList.remove('is--visible');
        }
        this.$overlay.classList.remove('is--visible');
        this.overlayOpen = false;
    }

    initSlider () {
        this.setSliderHeight();

        this.slider = new Swiper(this.$overlaySlider, {
            modules: [Pagination, FreeMode, Mousewheel],
            slidesPerView: 'auto',
            speed: 1000,
            spaceBetween: 20,
            slideClass: 'side-overlay__slider-item',
            wrapperClass: 'side-overlay__slider-items',
            mousewheel: {
                forceToAxis: true
            },
            freeMode: {
                enabled: true,
                sticky: true
            },
            pagination: {
                el: '.side-overlay__slider-pagination',
                type: 'progressbar'
            },
            breakpoints: {
                768: {
                    direction: 'vertical'
                }
            }
        });
    }

    setSliderHeight () {
        const windowWidth = window.innerWidth;
        const $sliderContainer = this.$overlaySlider.querySelector('.side-overlay__slider-items');
        if (windowWidth > 767) {
            const $sliderItems = this.$overlaySlider.querySelectorAll('[data-side-overlay-slider="slide"]');
            if ($sliderItems.length > 0) {
                let maxHeight = 0;
                for (let i = 0; i < $sliderItems.length; i++) {
                    const $slideItem = $sliderItems[i];
                    const slideItemHeight = $slideItem.offsetHeight;
                    if (slideItemHeight > maxHeight) {
                        maxHeight = slideItemHeight;
                    }
                }

                $sliderContainer.style.maxHeight = maxHeight + 'px';
            }
        } else {
            $sliderContainer.style.maxHeight = 'none';
        }
    }

    resizeSlider () {
        window.resizeHandler.customFunctions.push(() => {
            this.slider.destroy();
            this.initSlider();
        });
    }

    initSizeFinder () {
        const sizeFinderUrl = this.$sideOverlayButton.getAttribute('data-size-finder');
        const $sizeFinderInnerSlider = this.$overlay.querySelector('[data-side-overlay="inner"] .size-finder__steps');

        this.sizeFinderResult = new AjaxLoad(sizeFinderUrl, {
            onSuccess: (resultText) => {
                $sizeFinderInnerSlider.innerHTML = resultText;
                const $form = this.$overlay.querySelector('form');
                this.initFormSubmit($form);
                this.initSizeFinderSlider();
                this.setBackEvent();
            }
        });
    }

    initFormSubmit ($form) {
        const $inputs = $form.querySelectorAll('input');
        for (let i = 0; i < $inputs.length; i++) {
            const $input = $inputs[i];

            if ($input.type !== 'hidden') {
                $input.addEventListener('click', () => {
                    if (!this.isLoading) {
                        this.isLoading = true;
                        $input.classList.add('is--disabled');
                        this.changeSizeFinder($form, $input);
                    }
                });
            }
        }
    }

    changeSizeFinder ($form, $input) {
        let formAction = $form.getAttribute('action');
        const formMethod = $form.getAttribute('method');
        const formData = new FormData($form);

        // get all hidden inputs and add values to form action query
        const $hiddenInputs = $form.querySelectorAll('input[type="hidden"]');
        if ($hiddenInputs.length > 0) {
            for (let i = 0; i < $hiddenInputs.length; i++) {
                const $input = $hiddenInputs[i];
                const name = $input.name;
                const value = $input.value;
                let prefix = '&';
                if (name === 'step') {
                    prefix = '?';
                }
                const inputQuery = prefix + name + '=' + value;
                formAction = formAction + inputQuery;
            }
        }

        // add changed input to form action query
        const changedInput = $input;
        const changedInputName = changedInput.name;
        const changedInputValue = changedInput.value;
        const changedInputQuery = '&' + changedInputName + '=' + changedInputValue;
        formAction = formAction + changedInputQuery;

        this.formResult = new AjaxLoad(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            onSuccess: (resultText) => {
                this.sizeFinderSliderAddStep(resultText);
                $input.classList.remove('is--disabled');
                this.isLoading = false;
            }
        });
    }

    initSizeFinderSlider () {
        if (this.$sizeFinderSlider) {
            this.sizeFinderSlider = new Swiper(this.$sizeFinderSlider, {
                modules: [Manipulation],
                slidesPerView: 1,
                slideClass: 'size-finder__step',
                wrapperClass: 'size-finder__steps',
                allowTouchMove: false,
                spaceBetween: 20
            });
        }
    }

    sizeFinderSliderAddStep ($slide) {
        this.sizeFinderSlider.appendSlide($slide);
        this.sizeFinderSlider.slideTo(this.sizeFinderSlider.slides.length - 1);
        const $form = this.sizeFinderSlider.slides[this.sizeFinderSlider.slides.length - 1].querySelector('form');
        if ($form) {
            this.initFormSubmit($form);
        }
        if (this.sizeFinderSlider.slides.length > 1) {
            if (this.$sizeFinderBack) {
                this.$sizeFinderBack.classList.add('is--visible');
            }
        }

        const $endButton = this.sizeFinderSlider.slides[this.sizeFinderSlider.slides.length - 1].querySelector('[data-size-finder="end"]');
        const $restartButton = this.sizeFinderSlider.slides[this.sizeFinderSlider.slides.length - 1].querySelector('[data-size-finder="restart"]');
        if ($endButton && $restartButton) {
            this.sizeFinderEndButtonEvents($endButton, $restartButton);
        }
    }

    sizeFinderSliderRemoveStep (slideIndex) {
        this.sizeFinderSlider.slideTo(slideIndex - 1);
        if (this.sizeFinderSlider.slides.length === 2) {
            if (this.$sizeFinderBack) {
                this.$sizeFinderBack.classList.remove('is--visible');
            }

            const $radioInputs = this.$sizeFinderSlider.querySelectorAll('input[type="radio"]');
            if ($radioInputs.length > 0) {
                for (let i = 0; i < $radioInputs.length; i++) {
                    const $radioInput = $radioInputs[i];
                    $radioInput.checked = false;
                }
            }
        }
        setTimeout(() => {
            this.sizeFinderSlider.removeSlide(slideIndex);
        }, 1000);
    }

    setBackEvent () {
        if (this.$sizeFinderBack) {
            this.$sizeFinderBack.addEventListener('click', (e) => {
                const slideIndex = this.sizeFinderSlider.slides.length - 1;
                this.sizeFinderSliderRemoveStep(slideIndex);
                e.stopImmediatePropagation();
            });
        }
    }

    sizeFinderEndButtonEvents ($endButton, $restartButton) {
        if ($endButton) {
            $endButton.addEventListener('click', () => {
                const $resultsItems = $endButton.parentNode.querySelectorAll('.size-finder__results-item');
                const $sizeItems = document.querySelectorAll('.detail-stage__sizes-item');

                for (let i = 0; i < $sizeItems.length; i++) {
                    $sizeItems[i].classList.remove('is--active');
                }
                for (let i = 0; i < $resultsItems.length; i++) {
                    const $resultItem = $resultsItems[i];
                    const itemId = $resultItem.getAttribute('data-result-id');

                    for (let j = 0; j < $sizeItems.length; j++) {
                        const $sizeItem = $sizeItems[j];
                        const sizeId = $sizeItem.getAttribute('data-size-item-id');

                        if (itemId === sizeId) {
                            $sizeItem.classList.add('is--active');
                        }
                    }
                }

                this.closeOverlay();
            });
        }

        if ($restartButton) {
            $restartButton.addEventListener('click', () => {
                for (let i = this.sizeFinderSlider.slides.length - 1; i > 0; i--) {
                    this.sizeFinderSliderRemoveStep(i);
                }
            });
        }
    }
}

export { SideOverlay };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $sideOverlays = $context.querySelectorAll('[data-side-overlay="open"]');
        if ($sideOverlays.length > 0) {
            $sideOverlays.forEach((sideOverlay) => {
                const $sideOverlay = new SideOverlay(sideOverlay);
                $sideOverlay.initialize();
            });
        }
    }
});
